import { useState, type ComponentType } from "react";
import { Lock } from "lucide-react";

type LoginComponent = ComponentType<{ initiallyOpen?: boolean }>;

// Keep the public-page trigger lightweight. Auth/session cleanup in the root
// remains eager, so sign-out still clears cached private data immediately.
export function DeferredAdminLogin() {
  const [Login, setLogin] = useState<LoginComponent | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  async function openLogin() {
    if (loading) return;
    setLoading(true);
    setError(false);
    try {
      const module = await import("./AdminLoginWidget");
      setLogin(() => module.AdminLoginWidget);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  if (Login) return <Login initiallyOpen />;

  return (
    <div style={{ position: "fixed", bottom: "1rem", right: "1rem", zIndex: 50, display: "flex", alignItems: "center", gap: 8 }}>
      {error && <span role="alert" style={{ background: "var(--bg-surface)", color: "var(--text-primary)", padding: 8 }}>Login konnte nicht geladen werden. Bitte erneut versuchen.</span>}
      <button
        type="button"
        onClick={openLogin}
        disabled={loading}
        aria-busy={loading}
        aria-label={loading ? "Admin-Login wird geladen" : "Admin-Login"}
        title="Admin"
        style={{
          width: 42, height: 42, borderRadius: "50%", flexShrink: 0,
          background: "var(--bg-surface, #0d0d12)",
          border: "1px solid var(--text-muted, #888)",
          color: "var(--text-muted, #888)", cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.35)",
        }}
      >
        <Lock size={16} aria-hidden="true" />
      </button>
    </div>
  );
}
